import { IFuelPriceLayer } from 'types/fuelDeliveries.interface'

export const FUEL_PRICE_LAYERS: IFuelPriceLayer[] = [
  {
    id: 1,
    label: 'Opening stock — 1 May',
    pricePerL: 12.4,
    litres: 21114,
    source: 'Carried at prior weighted average',
  },
  {
    id: 2,
    label: 'Delivery 12 May — Sabel Fuels',
    pricePerL: 12.1,
    litres: 2000,
    source: 'Remaining of 8,000 L received',
  },
  {
    id: 3,
    label: 'Deliveries 17–24 Jun',
    pricePerL: 12.35,
    litres: 14880,
    source: 'Remaining of 42,650 L received',
  },
  {
    id: 4,
    label: 'Delivery 1 Jul — Sabel Fuels',
    pricePerL: 12.55,
    litres: 8960,
    source: 'Measured-in on receipt',
  },
]

export const priceLayers = FUEL_PRICE_LAYERS

export const currentWacPerL = (): number => {
  const litres = FUEL_PRICE_LAYERS.reduce((sum, layer) => sum + layer.litres, 0)
  const value = FUEL_PRICE_LAYERS.reduce((sum, layer) => sum + layer.litres * layer.pricePerL, 0)
  if (!litres) return 0
  return Math.round((value / litres) * 100) / 100
}

export const priceLayerValueGhs = (layer: IFuelPriceLayer): number =>
  Math.round(layer.litres * layer.pricePerL * 100) / 100
